import { Pencil } from "lucide-react";

export function EditActionButton({
  label,
  onClick,
  disabled = false,
}: {
  label: string;
  onClick: () => void;
  disabled?: boolean;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="focus-ring inline-flex min-h-10 items-center gap-2 rounded-full border border-[#14B8A6] bg-[#E8FFFC] px-4 text-sm font-semibold text-[#0F172A] shadow-[0_10px_24px_rgba(20,184,166,.12)] transition hover:bg-[#D6FFFA] disabled:cursor-not-allowed disabled:opacity-50"
    >
      <Pencil className="size-4 text-[#14B8A6]" aria-hidden="true" />
      {label}
    </button>
  );
}
